export default __webpack_public_path__ + "static/media/more.127b4de2.svg";